import * as React from 'react';
import { connect } from 'react-redux';
import { Grid, GridColumn as Column, GridFilterChangeEvent, GridPageChangeEvent, GridSortChangeEvent } from '@progress/kendo-react-grid';
import { orderBy, filterBy } from '@progress/kendo-data-query';
import { modeuleList, filterModuleList, pageModuleList, sortModuleList, deleteModule, unmountModuleListResponse } from 'src/actions/action.module';
import { EditUserWrapper } from 'src/styles/edituser';
import editModuleButton from './EditModuleButton';
import { DeleteModuleContext } from '../common/context';
import { ApplicationMain } from 'src/styles/common';
import * as PropTypes from 'prop-types';
import { Typography, Button, Grid as BootstrapGrid } from '@material-ui/core';
import ConfirmationComponent from '../common/notification/ConfirmationComponent';
import { DELETE_CONFIRAMATION } from 'src/constants/NotificationMessageConstant';
import LoaderComponent from '../common/loader.component';

class ModuleListComponent extends React.Component<any, any> {
    static contextTypes = {
        router: PropTypes.object,

    }
    constructor(props: any, context: any) {
        super(props, context);
        this.state = {
            moduleId: 0,
            isConfirmDialogShow: false
        }
        this.deleteModule = this.deleteModule.bind(this);
        this.handleDialogSubmit = this.handleDialogSubmit.bind(this);
        this.onCloseConfirmation = this.onCloseConfirmation.bind(this);
    }

    componentDidMount() {
        this.props.pageModuleList({
            skip: 0,
            take: 10
        });
        this.props.moduleList();
    }

    filterModuleList = (e: GridFilterChangeEvent) => {
        this.props.filterModuleList(e.filter);
        this.props.pageModuleList({skip: 0, take: 10});
    }

    pageModuleList = (event: GridPageChangeEvent) => {
        this.props.pageModuleList(event.page);
    }

    sortModuleList = (event: GridSortChangeEvent) => {
        this.props.sortModuleList(event.sort);
        this.props.pageModuleList({skip: 0, take: 10});
    }

    deleteModule(moduleId: number) {
        this.setState({ moduleId, isConfirmDialogShow: true });
    }

    updateModuleList = () => {
        this.props.moduleList();
    }

    styles = (theme: any) => ({
        root: {
            flexGrow: 1,
        },
        paper: {
            padding: theme.spacing.unit * 2,
            textAlign: 'center',
            color: theme.palette.text.secondary,
        },
    });

    handleAddNewModule = () => {
        this.context.router.history.push('/module/');
    }

    handleDialogSubmit() {
        this.props.deleteModule(this.state.moduleId);
        this.setState({ isConfirmDialogShow: false });
    }

    onCloseConfirmation() {
        this.setState({
            isConfirmDialogShow: false
        });
    }

    componentWillUnmount() {
        this.props.unmountModuleListResponse(null);
    }

    render() {
        return (
            <ApplicationMain>
                <DeleteModuleContext.Provider value={{
                    deleteModule: this.deleteModule
                }}>
                    <LoaderComponent sending={this.props.show} />
                    <ConfirmationComponent handleDialogSubmit={this.handleDialogSubmit} message={DELETE_CONFIRAMATION} onCloseConfirmation={this.onCloseConfirmation} open={this.state.isConfirmDialogShow} />
                    <EditUserWrapper>
                        <div className="pageContainer">
                            <div className="pageHeading">
                                <BootstrapGrid container={true} spacing={0} >
                                    <BootstrapGrid item={true} xs={6}>
                                        <div className="pageHeadingTitle">
                                            <Typography component="h2" variant="title" align="left" gutterBottom={true} className="pageTitle">
                                                Modules
                                            </Typography>
                                        </div>
                                    </BootstrapGrid>
                                    <BootstrapGrid item={true} xs={6}>
                                        <div className="text-right">
                                            <Button type="button" className="btn-blue" variant="outlined" size="medium" onClick={this.handleAddNewModule}>
                                                Add New Module
                                            </Button>
                                        </div>
                                    </BootstrapGrid>
                                </BootstrapGrid>
                            </div>
                            <div className="pageContent">
                                <div className="editUserScreen">
                                    <div className="kendoWrapper">
                                        <Grid
                                            data={orderBy(filterBy(this.props.models, this.props.filter), this.props.sort).slice(this.props.skip, this.props.take + this.props.skip)}
                                            filterable={true}
                                            filter={this.props.filter}
                                            onFilterChange={this.filterModuleList}
                                            skip={this.props.skip}
                                            take={this.props.take}
                                            total={filterBy(this.props.models, this.props.filter).length}
                                            pageable={true}
                                            onPageChange={this.pageModuleList}
                                            sortable={{
                                                allowUnsort: true,
                                                mode: 'multiple'
                                            }}
                                            sort={this.props.sort}
                                            onSortChange={this.sortModuleList}
                                        >
                                            <Column field="name" title="Name" filterable={true} />
                                            <Column field="module_type" title="Module Type" filterable={true} />
                                            <Column field="module_category" title="Module Category" filterable={true} />
                                            <Column field="isActive" title="Actions" filterable={false} cell={editModuleButton} />
                                        </Grid>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </EditUserWrapper>
                </DeleteModuleContext.Provider>
            </ApplicationMain>
        );
    }
}

const mapStateToProps = (state: any) => {
    return {
        show: state.common.show,
        models: state.model.models,
        filter: state.model.filter,
        skip: state.model.page.skip,
        take: state.model.page.take,
        sort: state.model.sort
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        moduleList: () => dispatch(modeuleList()),
        filterModuleList: (data: any) => dispatch(filterModuleList(data)),
        pageModuleList: (data: any) => dispatch(pageModuleList(data)),
        sortModuleList: (data: any) => dispatch(sortModuleList(data)),
        deleteModule: (data: any) => dispatch(deleteModule(data)),
        unmountModuleListResponse: (data: any) => dispatch(unmountModuleListResponse(data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ModuleListComponent);



// WEBPACK FOOTER //
// ./src/components/modules/ModuleListComponent.tsx